/* eslint-disable no-unused-vars */
import axios from "axios";
import { app } from "@/firebase/init.js";
import {
  getDatabase,
  ref,
  onValue,
  limitToLast,
  set,
  update,
  push,
  child,
  query as dbQuery,
  orderByChild,
} from "firebase/database";

const database = getDatabase(app);

const notificationModule = {
  namespaced: true,
  state: {
    notifications: [],
    contents: {
      ADMIN_COMMENT:
        "تم انشاء تعليق _COMMENT_COMMENT_ بواسطة _USER_NAME_  بنجاح على فيديو _VIDEO_TITLE_",
      ADMIN_REPLY: "تم اضافة رد _COMMENT_COMMENT_ على فيديو _VIDEO_TITLE_",
      REMOVE_COMMENT:
        "تم حذف التعليق التالي _COMMENT_COMMENT_ بواسطة _USER_NAME_ من الفيديو التالي _VIDEO_TITLE_",
      REMOVE_REPLY:
        "تم حذف الرد التالي _COMMENT_COMMENT_ بواسطة _USER_NAME_ من الفيديو التالي _VIDEO_TITLE_",
    },
    keys: ["_COMMENT_COMMENT_", "_VIDEO_TITLE_", "_USER_NAME_"],
    server_key:
      "AAAA9C8jxLo:APA91bELI7Fo1iP29d65BQPL-l1uRvA9q9CVYzf_xUUOQmD28BhHl6SCM4GrT45juBWPNkjbW3QKDG5MM1Kp9ucvKHXYGLeQYJ4aX-6w8Zr9lMiNQgvKNaZizfWiAtY6H9NiTPmDO8_6",
    count: 0,
    is_unread_count: 0,
  },
  getters: {
    notifications: (state) => state.notifications,
    count: (state) => state.count,
    isReadCount: (state) => state.is_unread_count,
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setCount(state, payload) {
      state.count = payload;
    },
    isUnread(state, payload) {
      state.is_unread_count = payload;
    },
  },
  actions: {
    async CreateMyNotify({ dispatch, state }, payload) {
      const { type, path, ...items } = payload;
      const _KEY_FROM_TYPE_ = state.contents[type];

      const keys = await dispatch("getKeys", {
        text: _KEY_FROM_TYPE_,
        keys: state.keys,
      });

      const notificationContent = await dispatch("replaceContent", {
        text: _KEY_FROM_TYPE_,
        keys,
        items,
      });

      const result = {
        result: {
          ...notificationContent,
          created_date: new Date().toISOString(),
          title: null,
          user_id: items.user.uid,
          ...items,
          path: path,
          is_read: false,
        },
        user: items.user,
        notify: notificationContent,
      };

      if (type === "REMOVE_COMMENT") {
        Object.assign(result, {
          title: "حذف تعليق",
        });
        dispatch("SendNotificationAndStore", result);
      } else if (type === "ADMIN_COMMENT") {
        Object.assign(result, {
          title: "اضافة تعليق جديد",
        });
        dispatch("SendNotificationAndStore", result);
      } else if (type === "ADMIN_REPLY") {
        Object.assign(result, {
          title: "اضافة رد جديد",
        });
        dispatch("SendNotificationAndStore", result);
      } else if (type === "REMOVE_REPLY") {
        Object.assign(result, {
          title: "حذف رد على تعليق",
        });
        dispatch("SendNotificationAndStore", result);
      }
    },

    SendNotificationAndStore({ dispatch, state }, { user, result, notify }) {
      // send notification to current admin
      axios.post(
        "https://fcm.googleapis.com/fcm/send",

        {
          notification: {
            title: "New comment",
            body: notify.content,
            click_action: "http://localhost:3000/",
          },
          to: user.FCT,
        },
        {
          headers: {
            Authorization: `key=${state.server_key}`,
          },
        }
      );

      // store data
      dispatch("storeNotification", result);
    },

    replaceContent(_, { text, keys, items }) {
      return new Promise((resolve) => {
        let keysResult = {};
        let result = {};
        let keyResult = {};
        let content = null;

        const replaceKeys = keys.map((e) => (e = e.replace(/(-|_)/g, " ")));

        for (let key = 0; key < replaceKeys.length; key++) {
          const item = replaceKeys[key];
          const splitKey = item.split(/\s/g).filter((e) => e);
          keysResult[splitKey[0]] = splitKey[splitKey.length - 1];
        }

        for (const key in keysResult) {
          if (key in keysResult) {
            const item = keysResult[key].toLowerCase();
            const lowerKey = key.toLowerCase();
            if (items[lowerKey]) {
              result[lowerKey] = items[lowerKey][item];
            }
          }
        }

        for (let i = 0; i < keys.length; i++) {
          const item = keys[i];
          keyResult[item] = Object.keys(result).find((e) =>
            new RegExp(e, "gi").test(item)
          );
        }

        // get content
        content = text.replace(new RegExp(`${keys.join("|")}`, "g"), (e) => {
          return keyResult[e] ? result[keyResult[e]] : e;
        });
        resolve({
          body: text,
          keys: result,
          tags: keyResult,
          content,
        });
      });
    },

    getKeys(_, { text, keys }) {
      let textKeys = null;
      textKeys = text.match(new RegExp(`${keys.join("|")}`, "g"));

      return textKeys;
    },

    async getAllNotifications({ dispatch, commit }, payload) {
      const value = (await dispatch("_GENERATE_NOTIFICATION_LENGTH_")) || 6;
      const notificationsRef = dbQuery(
        ref(database, `Notifications/${payload}`),
        orderByChild("created_date"),
        limitToLast(value)
      );

      onValue(notificationsRef, async (snapshot) => {
        const count = await dispatch("_GET_LENGTH_", {
          data: ref(database, `Notifications/${payload}`),
        });
        const data = snapshot.val();
        commit("setCount", count);

        commit(
          "setNotifications",
          data
            ? Object.entries(data)
                .map(([key, value]) =>
                  Object.assign(value, {
                    id: key,
                  })
                )
                .sort(() => -1)
            : []
        );
      });
    },

    _GET_LENGTH_({ commit }, { data }) {
      return new Promise((resolve) =>
        onValue(data, (snapshot) => {
          const notifications = snapshot.val();
          if (notifications) {
            commit(
              "isUnread",
              Object.values(notifications).filter((e) => !e.is_read).length
            );
            resolve(Object.values(notifications).length);
          }
        })
      );
    },
    _GENERATE_NOTIFICATION_LENGTH_({ state }) {
      const notifications = state.notifications;
      const count = state.count;

      const length = count - (notifications || []).length;
      if (length) {
        if (length >= 6) {
          return (notifications || []).length + 6;
        } else {
          return (notifications || []).length + length;
        }
      }
      return length;
    },
    async storeNotification({ commit, state }, payload) {
      // const notificationRef = ref( database, `Notifications/${payload.user_id}` );
      const childRefKey = push(
        child(ref(database), `Notifications/${payload.user_id}`)
      ).key;
      // const childRef = ref(database, 'Notifications/' + payload.user_id);
      await set(
        ref(database, "Notifications/" + payload.user_id + "/" + childRefKey),
        { ...payload }
      );

      // commit('setNotifications', [...state.notifications, payload]);
    },
  },
  module: {},
  plugins: {},
};

export default notificationModule;
